export function useAuditCopyToClipboard(): {
  hasCopyToClipboard: (fieldId: string) => boolean
} {
  const fieldsToCopyRegex = /id|url/i

  function hasCopyToClipboard(fieldId: string): boolean {
    return fieldsToCopyRegex.test(fieldId)
  }

  return {
    hasCopyToClipboard,
  }
}
